import * as React from 'react';
export const LameVerticalSelected = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M2.898 45.6V2.4h43.2v43.2z" fill="#13123A" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 48V0h48v48zm2.4-2.4h43.2V2.4H2.9z" fill="#fff" />
        <path
            d="M10.2 45.6h-2V2.4h2zm7.75 0h-2V2.4h2zm7.75 0h-2V2.4h2zm7.75 0h-2V2.4h2zm7.75 0h-2V2.4h2z"
            fill="#fff"
        />
    </svg>
);
